export default function CcmPage() {
  return (
    <div className="placeholder-page">
      <h1>Chat Chess Moves</h1>
      <p>Coming soon!</p>
    </div>
  );
}
